import React, { useState } from "react";
import { Field } from "../Fields";
import { filterDictionaryEntries } from "./dictionaryUtils";

/** Jawny wybór rekordu z kopii słownika dołączonej do zlecenia. */
export default function DictionaryRecordPicker({
  dictionaries,
  label,
  selectLabel,
  disabled,
  onSelect,
}) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  if (!dictionaries.length) return null;
  const entries = dictionaries.flatMap((dictionary) =>
    dictionary.entries.map((entry) => ({ ...entry, dictionary })),
  );
  const filtered = filterDictionaryEntries(entries, search);
  return (
    <details className="premium-dictionary-picker">
      <summary>{label}</summary>
      <p className="small text-muted">
        Wybierz zapisane dane. Po wybraniu możesz je poprawić dla tego
        świadectwa.
      </p>
      <Field
        label="Szukaj w słowniku"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />
      {!entries.length && (
        <p>
          Słownik był pusty przy dodawaniu dokumentów. Uzupełnij dane ręcznie;
          nowe wpisy będą dostępne w kolejnych zleceniach.
        </p>
      )}
      {entries.length > 0 && !filtered.length && <p>Brak pasujących wpisów.</p>}
      <ul className="premium-dictionary-choices">
        {filtered.map((entry) => (
          <li key={`${entry.dictionary.kind}:${entry.key}`}>
            <strong>{entry.key}</strong>
            <dl>
              {entry.dictionary.fields.map((field) => (
                <div key={field.key}>
                  <dt>{field.label}</dt>
                  <dd>{entry.value[field.key]}</dd>
                </div>
              ))}
            </dl>
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              disabled={disabled}
              onClick={() => {
                onSelect({ ...entry.value });
                setSelected(entry.key);
              }}
            >
              {selectLabel}
            </button>
          </li>
        ))}
      </ul>
      {selected && (
        <p role="status" className="small text-muted">
          Przepisano dane: {selected}.
        </p>
      )}
    </details>
  );
}
